import type { FaireProductEntity } from "../../entity_types/product";

export const p_j9gz66x5z8: FaireProductEntity = {
  token: "p_j9gz66x5z8",
  type: "product",
  name: 'Wide Base Mug with Loons-3.5"H(14oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/97714eff9cb0037561317e21f975c6618b66cfeb0dbfbf21556f8c3ac7e6de33.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5fb8590bd455f948445bc80aff8a4be92be9963aac8cc662ac39b8cf4f13e802.jpeg",
    "https://cdn.faire.com/fastly/667c2a5cd1be2166c45560e4798eb32fbf3d24c8e417dc773f8bec22348ab71a.jpeg",
    "https://cdn.faire.com/fastly/05a08ce67225c32fc6ad16828bcceda23a8b9d7a5b84b8b51f1a481157bbdad6.jpeg",
  ],
  priceDollars: 5,
  description:
    "Introducing our Wide Base Mug with Tree of Life. This generously sized, 14oz mug features a sturdy wide base for stability and a beautifully detailed Tree of Life icon, symbolizing growth and strength. Perfect for enjoying your favorite hot beverages, it combines functionality with an elegant design.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:11.610Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
